import { FC, useState } from 'react'

type RobotInputProps = {
  onChange: (name: string, value: string) => void
}

const RobotInput: FC<RobotInputProps> = ({ onChange }) => (
  <div className="hidden">
    <label>
      Fill if you are Skynet
      <input
        name="bot-field"
        onChange={(e) => {
          e.preventDefault()
          const { name, value } = e.target
          onChange(name, value)
        }}
      />
    </label>
  </div>
)

export default RobotInput
